<template>
  <div class="card col-xl-12 col-lg-12">
    <div class="card-header card-header-flex flex-column">
      <a-tabs
        class="kit-tabs"
        :default-active-key="activeKey"
        @change="callback"
      >
        <a-tab-pane
          :tab="this.$t('scolarite.modules')"
          key="1"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          v-if="
            !verifyPackAccess('bulletinPilote', 'h') &&
            verifySchoolType('primaire')
          "
          :tab="this.$t('scolarite.modulesSpec')"
          key="2"
          :disabled="verifyPackAccess('bulletinPilote', 'd')"
        />
        <a-tab-pane
          v-if="
            !verifyPackAccess('bulletinSpecific', 'h') &&
            verifySchoolType('primaire')
          "
          :tab="this.$t('scolarite.modulesVerySpec')"
          key="3"
          :disabled="verifyPackAccess('bulletinSpecific', 'd')"
        />
        <a-tab-pane
          :tab="this.$t('bulletin.bulletin')"
          key="10"
          v-if="verifySchoolType('college')"
        />

        <a-tab-pane
          :tab="this.$t('scolarite.affichageParametrage')"
          key="4"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('scolarite.certification')"
          key="5"
          v-if="verifySchoolType('primaire') || verifySchoolType('college')"
        />
        <a-tab-pane
          :tab="this.$t('scolarite.appreciation')"
          key="6"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('appreciation.automatic')"
          key="11"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="`${this.$t('appreciation.automatic')} (${this.$t('etablissement.collegeEtLycee')})`"
          key="12"
          v-if="verifySchoolType('college')"
        />
        <a-tab-pane
          :tab="this.$t('bulletin.ConsielClass')"
          key="14"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('bulletinBuilder.adminAppreciation')"
          key="7"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('decisionConseil.decisionConseil')"
          key="8"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('bulletin.bulletinCoefs')"
          key="9"
          v-if="verifySchoolType('primaire')"
        />
        <a-tab-pane
          :tab="this.$t('bulletin.annualReport')"
          key="13"
          v-if="verifySchoolType('primaire') || verifySchoolType('college')"
        />

        <!--<a-tab-pane :tab="this.$t('bulletin.custom')" key="11" /> -->
      </a-tabs>
    </div>
    <div class="card-body">
      <!--<keep-alive>-->
      <module-generale
        v-if="['1', '2', '3'].includes(activeKey)"
        :key="'m' + loadKey"
        :type="type"
      />
      <component
        v-else
        v-bind:is="currentTabComponent"
        :key="'e' + loadKey"
      ></component>
      <!--</keep-alive>-->
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import certification from "./components/certification";
import appreciation from "./components/appreciation";
import automaticAppreciation from "./components/automaticAppreciation";
import adminAppreciation from "./components/adminAppreciation";
import decisionConseil from "./components/decisionConseil";
import bulletinCoef from "./components/bulletinCoef";
import moduleGenerale from "./components/moduleGenerale";
import bulletinBuilder from "./components/bulletinBuilder";
import bulletinCollegeConfig from "./components/bulletinCollegeConfig";
import automaticAppreciationCollege from "./components/automaticAppreciationCollege";
import annualReport from "./components/annualReport";
import ConseilClass from "./components/ConsielClass";
//import customBulletin from "./components/bulletinBuilder/custom";
import { mapState, mapGetters } from "vuex";
import {
  isPrimarySchoolType,
  isCollegeSchoolType,
} from "@/config/Constants";

export default {
  name: "etablissement",
  components: {
    certification,
    appreciation,
    automaticAppreciation,
    adminAppreciation,
    decisionConseil,
    bulletinCoef,
    moduleGenerale,
    bulletinBuilder,
    bulletinCollegeConfig,
    automaticAppreciationCollege,
    annualReport,
    ConseilClass,
    //customBulletin,
  },
  data() {
    return {
      activeKey: "10",
      loadKey: 0,
    };
  },
  created() {
    // Set activeKey based on school type
    const schoolType = this.schoolDetails?.type;
    if (isPrimarySchoolType(schoolType)) {
      this.activeKey = "1";
    } else {
      this.activeKey = "10";
    }
  },
  computed: {
    ...mapGetters("settings", ["packDetailsGetter"]),
    type: function () {
      switch (this.activeKey) {
        case "1":
          return "MP";
        case "2":
          return "MT";
        case "3":
          return "MS";
      }
    },
    currentTabComponent: function () {
      switch (this.activeKey) {
        case "4":
          return "bulletinBuilder";
        case "5":
          return "certification";
        case "6":
          return "appreciation";
        case "7":
          return "adminAppreciation";
        case "8":
          return "decisionConseil";
        case "9":
          return "bulletinCoef";
        case "10":
          return "bulletinCollegeConfig";
        case "12":
          return "automaticAppreciationCollege";
        case "11":
          return "automaticAppreciation";
        case "13":
          return "annualReport";
        case "14":
          return "ConseilClass";
        //case "11":
        //  return "customBulletin";
      }
    },
    ...mapState(["settings", "user"]),
    ...mapGetters("user", ["user"]),
    schoolDetails() {
      return (
        this.user.building.filter(
          (el) => el.dbName == this.settings.activeBuilding
        )[0] || {}
      );
    },
  },
  methods: {
    verifyPackAccess: function (item, type) {
      return this.packDetailsGetter.access.edManager[item] == type;
    },
    verifySchoolType(type) {
      if (type == "primaire")
        return isPrimarySchoolType(this.schoolDetails.type);
      else return isCollegeSchoolType(this.schoolDetails.type);
    },
    callback: function (key) {
      this.activeKey = key;
      this.loadKey += 1;
    },
  },
};
</script>

<style scoped>
::v-deep .ant-tabs-nav-wrap {
  overflow: hidden !important;
}
</style>
